import {
  SiReact,
  SiTypescript,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiTailwindcss,
  SiNodedotjs,
  SiExpress,
  SiMongodb,
  SiPostgresql,
  SiGit,
  SiGithub,
  SiDocker,
  SiFigma,
  SiNextdotjs,
  SiVite,
} from "react-icons/si";
import { Card, CardContent } from "@/components/ui/card";

import { motion } from "framer-motion";

const techCategories = [
  { name: "React", icon: SiReact, color: "#61DAFB" },
  { name: "TypeScript", icon: SiTypescript, color: "#3178C6" },
  { name: "JavaScript", icon: SiJavascript, color: "#F7DF1E" },
  { name: "Next.js", icon: SiNextdotjs, color: "#FFFFFF" },
  { name: "HTML5", icon: SiHtml5, color: "#E34F26" },
  { name: "CSS3", icon: SiCss3, color: "#1572B6" },
  { name: "Tailwind", icon: SiTailwindcss, color: "#06B6D4" },
  { name: "Node.js", icon: SiNodedotjs, color: "#339933" },
  { name: "Express", icon: SiExpress, color: "#FFFFFF" },
  { name: "MongoDB", icon: SiMongodb, color: "#47A248" },
  { name: "PostgreSQL", icon: SiPostgresql, color: "#4169E1" },
  { name: "Docker", icon: SiDocker, color: "#2496ED" },
];

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

export const TechStack = () => {
  return (
    <section id="tech" className="">
      {/* Background decoration */}
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16 space-y-4">
            <motion.h1
              variants={itemVariants}
              className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight"
            >
              Tech{" "}
              <span className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 bg-clip-text text-transparent">
                Stack
              </span>
            </motion.h1>
            <div className="w-20 h-1 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600  mx-auto rounded-full" />
            <p className="text-white text-base sm:text-lg max-w-2xl mx-auto">
              Technologies and tools I work with to bring ideas to life
            </p>
          </div>

          {/* Tech Categories */}
          <div className="space-y-12">
            <div className="space-y-6">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6">
                {techCategories.map((category, index) => {
                  const Icon = category.icon;
                  return (
                    <Card
                      key={index}
                      className="group bg-transparent border-blue-500/75 hover:border-blue/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10 hover:-translate-y-1"
                    >
                      <CardContent className="p-6 flex flex-col items-center justify-center space-y-3">
                        <div className="relative">
                          <div className="absolute inset-0 bg-blue-400/50 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                          <Icon
                            className="w-12 h-12 sm:w-14 sm:h-14 relative z-10 transition-transform duration-300 group-hover:scale-110"
                            style={{ color: category.color }}
                          />
                        </div>
                        <p className="text-sm sm:text-base font-medium text-[#f2f2f2] text-center">
                          {category.name}
                        </p>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
